<ng-container>
	<mat-card class="panel">
		<mat-card-content [ngStyle]="styleSize(10 + this.size[0] + 'px')">
			<div fxLayout="column">

				<mat-select (selectionChange)="changeSubtype();" [(value)]="subtype" style="font-weight:900">
					<mat-option *ngFor="let subtype of subtypes" value="{{subtype}}">
						{{subtype}}
					</mat-option>
				</mat-select>

				<canvas #score></canvas>
			</div>
		</mat-card-content>
	</mat-card>
</ng-container>
